import api from './APIService';

class ProfileService {
	getProfile(data) {
		return api.fetch({ method: 'post', path: '/participant/profile', data });
	}
	getProfileUsers(data) {
		return api.fetch({ method: 'post', path: '/participant/getProfileUsers', data });
	}
	updateField(data){
		return api.fetch({ method: 'put', path: '/participant/profile', data });
	}
	updateProfile(data){
		return api.fetch({ method: 'put', path: '/participant/profile/update', data });
	}
	googlePlacesUpdate(data)
	{
		return api.fetch({ method: 'put', path: '/participant/profile/googlePlacesUpdate', data });
	}
	updateEmail(data){
		return api.fetch({ method: 'put', path: '/participant/profile/email', data });
	}
	updateProfileImage(data){
		return api.fetch({ method: 'put', path: '/participant/profile/picture/', data });
	}
	deleteProfileImage(userId) {
		return api.fetch({ method: 'delete', path: '/participant/profile/' + userId });
	}
	updateProfileLanguage(data){
		return api.fetch({ method: 'put', path: '/participant/profile/language/', data });
	}
}

export default new ProfileService();
